export default {
  lightbox: {
    close: 'Fermer',
    previous: 'Précédent',
    next: 'Suivant'
  }
}